import { render, staticRenderFns } from "./PastProjectEditView.vue?vue&type=template&id=a1b7c7ba&"
import script from "./PastProjectEditView.vue?vue&type=script&lang=ts&"
export * from "./PastProjectEditView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports